import { S25WsNode } from "./S25WsNode";

export namespace Category {
    export enum SystemDefined {
        PublishTovCalendar = -1,
        HotEvent = -2, // 25Live Hot Event (not Connect25 promoted)
        StudentEngagement = -1_000,
        Connect25EventPrivate = -1_003,
        Connect25EventPublic = -1_004,
        Connect25EventPromoted = -1_009,
        Connect25OrgPromoted = -1_005,
        Connect25OrgPrivate = -1_006,
        Connect25OrgPublic = -1_007,
        StudentHousing = -10_000,
    }
    export interface DataI extends S25WsNode {
        category_id: number;
        category_name: string;
        category_defn_state: number;
    }
}
